export const LOGIN = 'LOGIN'
export const SIGNIN = 'SIGNIN'
export const LEVELUP = 'LEVELUP'
export const LEVEL = 'LEVEL'
